import { ChevronRight } from '@mui/icons-material';
import { ButtonBase, Stack, Typography } from '@mui/material';
import React from 'react';
import { getServiceKnowledge, SERVICE_WHITELIST } from '../Helper/integrationKnowledge';
import { ServiceAvatar } from './ServiceAvatar';

interface Props {
  onPick: (connectorKey: string) => void;
}

/**
 * The "what do you want to connect?" catalog: one row per connector, grouped
 * implicitly by catalog order. Systems with several connectors get one row per
 * variant with the variant chip next to the name.
 */
export const CatalogPicker = ({ onPick }: Props): React.JSX.Element => (
  <Stack spacing={1}>
    {SERVICE_WHITELIST.map((serviceName: string) => {
      const serviceKnowledge = getServiceKnowledge(serviceName);

      return (
        <ButtonBase
          key={serviceName}
          onClick={() => onPick(serviceName)}
          sx={{
            display: 'block',
            textAlign: 'left',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            p: 1.5,
            transition: 'border-color 120ms, background-color 120ms',
            '&:hover': { borderColor: 'primary.main', backgroundColor: 'action.hover' },
          }}
        >
          <Stack direction={'row'} spacing={1.5} alignItems={'center'}>
            <ServiceAvatar serviceName={serviceName} size={40} />
            <Stack spacing={0.25} sx={{ minWidth: 0, flexGrow: 1 }}>
              <Stack direction={'row'} alignItems={'center'} spacing={0.75}>
                <Typography fontWeight={700} noWrap>
                  {serviceKnowledge?.displayName ?? serviceName}
                </Typography>
                {/*hasVariants && connector.variantLabel && (
                    <Chip
                      label={connector.variantLabel}
                      size={'small'}
                      variant={'outlined'}
                      sx={{ height: 18, fontSize: 10, fontWeight: 700, '& .MuiChip-label': { px: 0.75 } }}
                    />
                  )*/}
                {/*<Typography variant={'caption'} color={'text.secondary'} noWrap>
                    {subtitle}
                  </Typography>*/}
              </Stack>
              {serviceKnowledge?.description && (
                <Typography variant={'caption'} color={'text.secondary'} noWrap>
                  {serviceKnowledge.description}
                </Typography>
              )}
              {/*<CapabilityChips capabilities={connectorCapabilities(connector.key)} />*/}
            </Stack>
            <ChevronRight sx={{ color: 'text.secondary', flexShrink: 0 }} />
          </Stack>
        </ButtonBase>
      );
    })}
  </Stack>
);
